import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      // SWR-like: show cached data fast, revalidate in background
      refetchOnWindowFocus: 'always',
      staleTime: 60_000, // 1 minute
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: 2,
    },
  },
});
